const moment = require("moment");

const formatPasActivationDate = pas => {
  if (!pas || !pas.activationDate) {
    return null;
  }

  const activationDate = moment(pas.activationDate);
  return activationDate.isValid() ? activationDate.format("MM/DD/YYYY") : null;
};

module.exports = {
  formatPasActivationDate
};
